<template>
  <div>
    <v-card cols="12">
      <v-row>
        <v-col>
          <div class="pa-6">
            <div v-if="loading" align="center">
              <v-progress-circular
                indeterminate
              ></v-progress-circular>
            </div>
            <div v-show="showChart">
              <v-card-text style="height: auto">
                <h2 align="center">
                    {{ $t("totalOnlineBalanceDescription") }}
                </h2>
              </v-card-text>
              <PieChart :data="data" :type="'totalOnlineBalance'" />
              <div v-if="!loading && showChart">
                <div class="text-right mb-1">
                  <span>
                    {{ $t("onlineBalance") }}:
                    <v-chip small color="orange darken-2"
                      >{{ brl(data.online_balance) }}
                    </v-chip></span
                  >
                </div>
                <div class="text-right">
                  <span>
                    {{ $t("bonusBalance") }}:
                    <v-chip small color="purple darken-2">
                      {{ brl(data.online_bonus_balance) }}
                    </v-chip>
                  </span>
                </div>
              </div>
            </div>
            <div v-show="!showChart && !loading">
                <div class="text-center">
                  <h3>
                    {{ $t("noDataForthisQuery") }}
                  </h3>
                </div>
          </div>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import PieChart from "@/components/Charts/PieChart";

export default {
  components: {
    PieChart,
  },
  data: () => ({
    data: {
      online_bonus_balance: '',
      online_balance: '',
    },
    loading: true,
    showChart: false
  }),
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$request
        .get("/administrator/players/totalOnlineBalance")
        .then((res) => {
          this.data = res.dados[0];
          this.showChart = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    brl(value) {
      if (!value) {
        return "";
      }
      
      return Number(value).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>
